"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.locales = exports.fallbackLng = void 0;
const i18next_1 = __importDefault(require("i18next"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const getLocale_1 = __importDefault(require("../getLocale"));
const en_json_1 = __importDefault(require("./en.json"));
const ja_json_1 = __importDefault(require("./ja.json"));
/** The language that uses as a fallback. */
exports.fallbackLng = 'en';
/**
 * The locales table.
 *
 * The property keys have ISO 639-1 string and values exact name.
 */
exports.locales = Object.freeze({ en: en_json_1.default.name, ja: ja_json_1.default.name });
/**
 * Create the resources object.
 * @param addition The additional resources.
 */
const initResources = (addition) => Object.entries(lodash_merge_1.default(addition, { en: en_json_1.default, ja: ja_json_1.default })).reduce((acc, [k, v]) => ({ ...acc, [k]: { translation: v } }), {});
/** Create and initialize the i18next instance asynchronously. */
exports.default = (options = {}) => {
    const { additions, lng = getLocale_1.default(), use } = options;
    const init = { lng, resources: initResources(additions) };
    return use ? i18next_1.default.use(use).init(init) : i18next_1.default.init(init);
};
//# sourceMappingURL=createTAsync.js.map